import apiClient from './apiClient';

const negociationService = {
  creer:          (data)        => apiClient.post('/negociations', data),
  creerContact:   (produitId)   => apiClient.post(`/negociations/contact/${produitId}`),
  lister:         (params = {}) => apiClient.get('/negociations', { params }),
  detail:         (id)          => apiClient.get(`/negociations/${id}`),
  repondre:       (id, data)    => apiClient.put(`/negociations/${id}/repondre`, data),
  envoyerMessage: (id, message) => apiClient.post(`/negociations/${id}/message`, { message }),
};

export default negociationService;
